import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-brand-petrol" data-id="element-172" data-mp="3ksqh3bq45o94">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-173" data-mp="3fxun461bgqtd">
        <h2 id="testimonios" className="font-display text-[2rem] leading-none text-white sm:text-5xl" data-id="element-174" data-mp="3azjetzqo6od9">
          Lo que dicen <span className="text-brand-mint" data-id="element-175" data-mp="36wmplq6mju0c">quienes ya empezaron</span>
        </h2>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-176" data-mp="31yl8hasre4ri">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-brand-mint bg-white p-2.5 text-left text-brand-petrol ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-177" data-mp="2x11pxyp135tr" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-178" data-mp="h67wpwq6ta6o">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-brand-gold text-brand-gold" data-id="element-179" data-mp="m5sz6h4kg0o5" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-180" data-mp="c7dht5vcc5ru">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-181" data-mp="14vj3pvy4s0t9">
                <p className="font-sub text-xs font-bold uppercase text-brand-emerald" data-id="element-182" data-mp="14uhi4xjhnvxa">
                  {t.author}
                </p>
                <p className="text-xs leading-snug text-brand-muted" data-id="element-183" data-mp="q4jxusoojqdd">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}